/**
 * Firebase Logger Patch
 * Patches Firebase SDK's internal logger to suppress connection error logs
 * This intercepts logs before they hit the console
 */

export function patchFirebaseLogger() {
  if (typeof window === 'undefined') return;

  // Patterns for Firebase messages to suppress
  const suppressPatterns = [
    'WebChannelConnection RPC',
    'transport errored',
    'Could not reach Cloud Firestore backend',
    'Connection failed',
    '[code=unavailable]',
  ];

  try {
    // Firebase uses @firebase/logger internally
    // We need to monkey-patch the logger function
    const firebaseNamespace = (window as any).firebase;
    
    if (!firebaseNamespace) {
      // Firebase not loaded yet, will patch after it loads
      setTimeout(patchFirebaseLogger, 500);
      return;
    }

    // Intercept at the console level since that's where Firebase logs eventually go
    // The patches in suppressFirebaseErrors.ts handle this
    
    // Additionally, try to suppress via the function logger if available
    if ((window as any).__FIREBASE_DEFAULTS__) {
      // Firebase is aware of logging configuration
      try {
        // Set firebase to minimal logging
        const oldLogLevel = (window as any).__FIREBASE_LOG_LEVEL__;
        (window as any).__FIREBASE_LOG_LEVEL__ = 'silent';
      } catch (e) {
        // Ignore
      }
    }

  } catch (e) {
    // Ignore if Firebase API is not available
    console.debug('[Firebase Logger Patch] Firebase not fully loaded yet');
  }
}

export default patchFirebaseLogger;
